let audioCtx;

function ctx() {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext ||
      window.webkitAudioContext)();
  }
  return audioCtx;
}

function beep({
  frequency = 800,
  duration = 0.15,
  type = "sine",
  volume = 0.3,
}) {
  const context = ctx();

  const oscillator = context.createOscillator();
  const gain = context.createGain();

  oscillator.type = type;
  oscillator.frequency.value = frequency;

  gain.gain.value = volume;

  oscillator.connect(gain);
  gain.connect(context.destination);

  oscillator.start();
  oscillator.stop(context.currentTime + duration);
}

/* ================= PUBLIC API ================= */

export function playSuccessSound() {
  beep({ frequency: 1200, duration: 0.12 });
  setTimeout(
    () => beep({ frequency: 1600, duration: 0.18 }),
    120
  );
}

export function playWarningSound() {
  beep({ frequency: 600, duration: 0.2 });
  setTimeout(
    () => beep({ frequency: 600, duration: 0.2 }),
    220
  );
}

export function playErrorSound() {
  beep({ frequency: 300, duration: 0.4, type: "square" });
}
